import { CPTBRow, HierarchyLevel, HierarchyLevelConst } from '../dtc-commerce-mmm-types';
import { formatFieldName } from '../hooks/useChannelAggregation';

// getAggregatedMediaType lives in useChannelAggregation (its primary consumer); re-exported
// here so existing importers of this module keep working.
export { getAggregatedMediaType } from '../hooks/useChannelAggregation';

export const normalizeChannelName = (name: string): string =>
  name.toLowerCase().replace(/_/g, ' ').trim();

export const getParentChannelKey = (
  groupKey: string,
  level: HierarchyLevel,
  cptb: CPTBRow[]
): string => {
  if (level === HierarchyLevelConst.CHANNEL) return groupKey;
  if (level === HierarchyLevelConst.PLATFORM || level === HierarchyLevelConst.TACTIC) {
    return groupKey.split('|')[0];
  }
  const row = cptb.find(r => r.name === groupKey);
  return row?.channel ?? '';
};

interface SubChannelLabelRow {
  platform: string;
  tactic: string;
  brandNonbrand: string;
  name: string;
}

export const getSubChannelLabel = (row: SubChannelLabelRow, viewLevel: HierarchyLevel): string => {
  const parts: string[] = [];
  if (viewLevel === HierarchyLevelConst.CHANNEL) {
    if (row.platform) {
      parts.push(formatFieldName(row.platform));
    }
    if (row.tactic) {
      parts.push(formatFieldName(row.tactic));
    }
    if (row.brandNonbrand) {
      parts.push(formatFieldName(row.brandNonbrand));
    }
  } else if (viewLevel === HierarchyLevelConst.PLATFORM) {
    if (row.tactic) {
      parts.push(formatFieldName(row.tactic));
    }
    if (row.brandNonbrand) {
      parts.push(formatFieldName(row.brandNonbrand));
    }
  } else if (viewLevel === HierarchyLevelConst.TACTIC) {
    if (row.brandNonbrand) {
      parts.push(formatFieldName(row.brandNonbrand));
    }
  }
  return parts.length > 0 ? parts.join(', ') : row.name;
};

export const subChannelDisplayName = (name: string): string => {
  const parts = name.split(', ');
  const display = parts.length > 1 ? parts.slice(1) : parts;
  return display.map(formatFieldName).join(', ');
};

export const formatDrawerDateRange = (startDate: string, endDate: string): string => {
  if (!startDate || !endDate) return '';
  const fmt = (d: string) => {
    const date = new Date(`${d}T00:00:00`);
    const mon = date.toLocaleDateString('en-US', { month: 'short' });
    const yr = String(date.getFullYear()).slice(2);
    return `${mon} '${yr}`;
  };
  return `${fmt(startDate)} – ${fmt(endDate)}`;
};
